import api from './api'

export const twoFactorService = {
  // Telegram 2FA Methods
  // Step 1: Verify Password
  verifyPassword: async (password) => {
    const response = await api.post('/2fa/telegram/verify-password', { password })
    return response.data
  },

  // Step 2: Generate Connection Code
  generateLinkCode: async () => {
    const response = await api.post('/2fa/telegram/generate-link-code')
    return response.data
  },

  // Disable 2FA
  disable2FA: async (otp) => {
    const response = await api.post('/2fa/telegram/disable-2fa', { otp })
    return response.data
  },

  // Send Disable Code
  sendDisableCode: async () => {
    const response = await api.post('/2fa/telegram/send-disable-code')
    return response.data
  },

  // Mobile App 2FA Methods
  // Generate QR Code and Secret for Mobile App
  generateMobileSetup: async () => {
    const response = await api.post('/2fa/mobile/generate-setup')
    return response.data
  },

  // Verify and Enable Mobile 2FA
  verifyMobileSetup: async (otp) => {
    const response = await api.post('/2fa/mobile/verify-setup', { otp })
    return response.data
  }
}
